import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 12a4 4 0 1 0 8 0a4 4 0 1 0 -8 0","key":"svg-0"}]]

const IconPoint = createReactComponent('outline', 'point', 'Point', __iconNode);

export default IconPoint;